/**
 * Copyright 2025 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import React, { ReactElement } from 'react';
import { SectionRowElement, UaPlaceholder } from 'templates/pubSub/types/TemplateType';
import { TemplateContext } from 'templates/pubSub/types/TemplateContextType';
import { usePubSubNode, usePubSubNodes } from 'utilities/PubSub/PubSubHooks';
import TemplateHelperPubSub from 'utilities/TemplateHelperPubSub';
import { NodeIdentifier } from 'utilities/PubSub/PubSubAddressSpace';
import SectionElementContent from './SectionElementContent';

interface ISectionElementPlaceholderProps {
  templateContext: TemplateContext;
  element: SectionRowElement;
  cols: string;
  placeholder: UaPlaceholder;
  placeholderIndex: number;
  startingNodeId?: NodeIdentifier;
}

export default function SectionElementPlaceholder(props: ISectionElementPlaceholderProps): ReactElement {
  const filter = TemplateHelperPubSub.createFilter(props.templateContext.namespaces, props.placeholder.variablePath);
  const node = usePubSubNode(filter, props.startingNodeId);
  const placeholderFilter = TemplateHelperPubSub.createReferenceAndTypeFilter(
    props.templateContext.namespaces,
    props.placeholder.reference,
    props.placeholder.type,
  );
  const placeholderNodes = usePubSubNodes(placeholderFilter, node);

  const nextPlaceholder =
    props.element.placeholders && props.element.placeholders.length > props.placeholderIndex + 1
      ? props.element.placeholders[props.placeholderIndex + 1]
      : undefined;

  return (
    <>
      {placeholderNodes.map((placeholderNode, placeholderNodeIndex) => (
        <>
          {nextPlaceholder ? (
            <SectionElementPlaceholder
              key={TemplateHelperPubSub.getPlaceholderObjectKey(props.element.id, placeholderNodeIndex)}
              templateContext={props.templateContext}
              cols={props.cols}
              element={props.element}
              placeholder={nextPlaceholder}
              placeholderIndex={props.placeholderIndex + 1}
              startingNodeId={placeholderNode}
            />
          ) : (
            <SectionElementContent
              templateContext={props.templateContext}
              cols={props.cols}
              element={props.element}
              startingNodeId={placeholderNode}
            />
          )}
        </>
      ))}
    </>
  );
}
